import React, { createContext, useReducer, useContext } from 'react';

// Define action types
const SET_USER = 'SET_USER';
const LOGOUT_USER = 'LOGOUT_USER';
const SET_LOADING = 'SET_LOADING';
const SET_INFO_MESSAGE = 'SET_INFO_MESSAGE';
const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
const SET_IS_MOBILE = 'SET_IS_MOBILE'
const SET_PROFILE = 'SET_PROFILE'
const SET_THEME = 'SET_THEME'
const SET_LAYOUT = 'SET_LAYOUT'

// Initial state
const initialState = {
    theme: localStorage.getItem('theme') || 'light',
    layout: localStorage.getItem('layout') || 'row',
    user: JSON.parse(localStorage.getItem('user')),
    isMobile: window.matchMedia("(max-width: 768px)").matches,
    errorMessage: null,
    //TODO: Add others..
};

// Create a context
const GlobalStateContext = createContext(initialState);
const GlobalDispatchContext = createContext(null);

// Reducer function to handle state changes
const globalReducer = (state, action) => {
    switch (action.type) {
        case SET_USER:
            return { ...state, user: action.payload };
        case LOGOUT_USER:
            return { ...state, user: null };
        case SET_LOADING:
            return { ...state, loading: action.payload };
        case SET_INFO_MESSAGE:
            return { ...state, infoMessage: action.payload };
        case SET_ERROR_MESSAGE:
            console.log( "SET_ERROR_MESSAGE", action.payload);
            return { ...state, errorMessage: action.payload };
        case SET_IS_MOBILE:
            return {...state, isMobile: action.isMobile};
        case SET_PROFILE:
            return {...state, profile: action.profile};
        case SET_THEME:
            return {...state, theme: action.theme};
        case SET_LAYOUT:
            return {...state, layout: action.layout};
        default:
            return state;
    }
};

let globalDispatch = null;

// GlobalStateProvider component to wrap the app
export const GlobalStateProvider = ({ children }) => {
    const [state, dispatch] = useReducer(globalReducer, initialState);
    globalDispatch = dispatch;
    return (
        <GlobalStateContext.Provider value={state}>
            <GlobalDispatchContext.Provider value={dispatch}>
                {children}
            </GlobalDispatchContext.Provider>
        </GlobalStateContext.Provider>
    );
};

// Utility function to get the global dispatch
export const getGlobalDispatch = () => globalDispatch;

// Custom hooks to use the global state and dispatch
export const useGlobalState = () => useContext(GlobalStateContext);
export const useGlobalDispatch = () => useContext(GlobalDispatchContext);

// Action creators
export const setUser = (user) => ({
    type: SET_USER,
    payload: user,
});
export const setLoading = (loading) => ({
    type: SET_LOADING,
    payload: loading
});
export const setInfoMessage = (infoMessage) => ({
    type: SET_INFO_MESSAGE,
    payload: infoMessage
});
export const setErrorMessage = (errorMessage) => {
    console.log( "!!setErrorMessage:", errorMessage);
    return {
        type: SET_ERROR_MESSAGE,
        payload: errorMessage
    };
}
export const setIsMobile = (isMobile) => ({
    type: SET_IS_MOBILE,
    isMobile
})
export const setProfile = (profile) => ({
    type: SET_PROFILE,
    profile
})
export const setTheme = (theme) => {
    localStorage.setItem('theme', theme);
    return {
        type: SET_THEME,
        theme
    }
}
export const setLayout = (layout) => {
    localStorage.setItem('layout', layout);
    return {
        type: SET_LAYOUT,
        layout
    }
}

export const logoutUser = () => ({
    type: LOGOUT_USER,
});
